const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1%2C%20gostaria%20de%20informa%C3%A7%C3%B5es%20t%C3%A9cnicas%20sobre%20as%20m%C3%A1quinas.";

interface CompareRow {
  criterio: string;
  cunha: string;
  extrusao: string;
}

const compareRows: CompareRow[] = [
  {
    criterio: "Princípio de soldagem",
    cunha: "Calor por condução com cunha aquecida — solda dupla com canal de teste",
    extrusao: "Fusão de fio de PEAD por rosca extrusora — solda monofacial",
  },
  {
    criterio: "Espessura recomendada",
    cunha: "0,5 – 3,0 mm (PEAD, PELBD, PVC)",
    extrusao: "1,5 – 5,0 mm (PEAD, PELBD)",
  },
  {
    criterio: "Velocidade de trabalho",
    cunha: "5 – 9 m/min (contínua)",
    extrusao: "0,5 – 2,0 m/min (manual)",
  },
  {
    criterio: "Temperatura de operação",
    cunha: "0 – 550°C (ajuste digital)",
    extrusao: "Até 700°C (fusão do fio)",
  },
  {
    criterio: "Aplicação ideal",
    cunha: "Grandes áreas planas: aterros, barragens, canais",
    extrusao: "Reparos, cantos, emendas, junções, reforços",
  },
  {
    criterio: "Teste de qualidade",
    cunha: "Teste de pressão no canal de teste (NBR 16199)",
    extrusao: "Ensaio de tração e corte (NBR 15352)",
  },
  {
    criterio: "Potência típica",
    cunha: "800 – 2100W",
    extrusao: "3400W",
  },
  {
    criterio: "Compatibilidade PVC",
    cunha: "Sim (BT950, WGW300, BT-GM1)",
    extrusao: "SIM",
  },
];

export default function TechnicalGuidesSection() {
  return (
    <section id="guias-tecnicos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="mb-16">
          <span className="text-green-500 text-xs uppercase tracking-widest mb-3 block">
            Conteúdo Técnico
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 uppercase leading-none mb-4">
            GUIAS E ESPECIFICAÇÕES<br />
            <span className="text-green-500">TÉCNICAS</span>
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed max-w-2xl">
            Informação técnica detalhada sobre <strong className="text-gray-700">soldagem de geomembrana</strong>,
            normas brasileiras e critérios de seleção de equipamentos para projetos de impermeabilização profissional.
          </p>
        </div>

        {/* ── 1. Como soldar geomembrana de PEAD ── */}
        <div id="soldagem-pead" className="mb-16 scroll-mt-24">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
              <i className="ri-tools-line text-green-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 uppercase tracking-wide">
              Como Soldar Geomembrana de <strong>PEAD</strong> Corretamente
            </h3>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Preparação */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500 text-white font-black text-sm">1</span>
                <h4 className="text-gray-900 font-black text-sm uppercase">Preparação da Superfície</h4>
              </div>
              <ul className="space-y-3 text-gray-500 text-sm leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Limpar a área de soldagem — remover lama, poeira, graxa e umidade</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Verificar temperatura ambiente: mínimo <strong>5°C</strong>, ideal entre <strong>15°C e 35°C</strong></span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Inspecionar a geomembrana: sem dobras, vincos ou danos mecânicos</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Preaquecer a máquina conforme especificação do fabricante (geralmente 5–10 min)</span>
                </li>
              </ul>
            </div>

            {/* Sobreposição */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500 text-white font-black text-sm">2</span>
                <h4 className="text-gray-900 font-black text-sm uppercase">Sobreposição e Soldagem</h4>
              </div>
              <ul className="space-y-3 text-gray-500 text-sm leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Sobreposição mínima de <strong>100 mm</strong> entre as bordas da geomembrana</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Alinhar a cunha quente no centro da sobreposição — solda dupla de <strong>20 mm</strong> cada</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Velocidade constante: <strong>5–8 m/min</strong> para PEAD de 1,5 mm (ajustar conforme espessura)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Temperatura de referência: <strong>380–420°C</strong> para PEAD de 1,0–2,0 mm</span>
                </li>
              </ul>
            </div>

            {/* Teste de qualidade */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500 text-white font-black text-sm">3</span>
                <h4 className="text-gray-900 font-black text-sm uppercase">Teste de Qualidade</h4>
              </div>
              <ul className="space-y-3 text-gray-500 text-sm leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>Teste de pressão no canal de teste</strong> — injetar ar a 1,5 bar por 5 minutos (NBR 16199)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>Teste de vazamento</strong> — sem queda de pressão após 5 minutos</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>Inspeção visual</strong> — solda uniforme, sem bolhas, queimaduras ou descontinuidades</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>Registro fotográfico</strong> de cada junta soldada para laudo técnico</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4 bg-green-50/60 rounded-xl border border-green-100 px-5 py-4">
            <p className="text-green-800 text-xs leading-relaxed">
              <i className="ri-information-line mr-1" />
              <strong>Nota técnica:</strong> A soldagem de geomembrana de <strong>PEAD</strong> exige controle rigoroso de temperatura e velocidade.
              Velocidade excessiva reduz a penetração do calor; velocidade baixa pode queimar o material.
              Sempre realize solda de teste (test weld) antes de iniciar a produção.
            </p>
          </div>
        </div>

        {/* ── 2. Mejor máquina para minería ── */}
        <div id="maquina-mineracao" className="mb-16 scroll-mt-24">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
              <i className="ri-hammer-line text-green-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 uppercase tracking-wide">
              Melhor Máquina para <strong>Mineração</strong>: Critérios de Seleção
            </h3>
          </div>

          <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-3xl">
            Projetos de mineração no Brasil exigem equipamentos robustos para soldagem de geomembranas de <strong>PEAD</strong>
            em espessuras de <strong>1,5 a 3,0 mm</strong>, em condições adversas de terreno, clima e carga mecânica.
            Abaixo, os critérios técnicos para seleção do equipamento ideal.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 mb-3">
                <i className="ri-dashboard-3-line text-green-600" />
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-2">Potência e Tração</h4>
              <p className="text-gray-500 text-xs leading-relaxed">
                Mínimo de <strong>1800W</strong> para geomembranas de 2,0 mm. Modelos com tração automática
                (como o <strong>BT950</strong> e <strong>WGW300</strong>) garantem velocidade constante em terrenos irregulares.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 mb-3">
                <i className="ri-thermometer-line text-green-600" />
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-2">Pressão e Temperatura</h4>
              <p className="text-gray-500 text-xs leading-relaxed">
                Pressão de contato entre <strong>800–1200 N</strong> e temperatura de <strong>400–500°C</strong> para fusão completa
                do PEAD em espessuras superiores a 2,0 mm sem degradação térmica.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 mb-3">
                <i className="ri-speed-line text-green-600" />
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-2">Velocidade de Produção</h4>
              <p className="text-gray-500 text-xs leading-relaxed">
                Velocidade de <strong>5–9 m/min</strong> em áreas planas. Em taludes e declives, a velocidade deve ser reduzida
                para <strong>3–5 m/min</strong> para manter a qualidade da solda.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 mb-3">
                <i className="ri-shield-check-line text-green-600" />
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-2">Resistência Mecânica</h4>
              <p className="text-gray-500 text-xs leading-relaxed">
                Estrutura reforçada em aço, proteção IP54 contra poeira e umidade, e sistema de refrigeração
                para operação contínua em jornadas de 8–10 horas.
              </p>
            </div>
          </div>

          <div className="bg-gray-900 rounded-2xl p-6 md:p-8">
            <h4 className="text-white font-black text-sm uppercase tracking-wide mb-4 flex items-center gap-2">
              <i className="ri-star-fill text-green-500" />
              Recomendação para Mineração no Brasil
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <p className="text-gray-300 text-sm leading-relaxed mb-3">
                  Para <strong className="text-white">pilhas de lixiviação, bacias de contenção e aterros de rejeitos</strong>,
                  recomendamos o <strong className="text-green-400">BT950 (2100W)</strong> como máquina principal de cunha quente
                  e a <strong className="text-green-400">Extrusora EX3 (3400W)</strong> para emendas de reforço e reparos.
                </p>
                <p className="text-gray-400 text-xs leading-relaxed">
                  Essa combinação atende às exigências da <strong className="text-gray-300">NBR 16199</strong> e é utilizada
                  em projetos de mineração em Minas Gerais, Pará e Goiás.
                </p>
              </div>
              <div className="flex items-center justify-center md:justify-end">
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-black text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
                >
                  <i className="ri-whatsapp-line" />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ── 3. Normas de soldadura en Brasil ── */}
        <div id="normas-soldagem" className="mb-16 scroll-mt-24">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
              <i className="ri-file-list-3-line text-green-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 uppercase tracking-wide">
              Normas de Soldagem de Geomembrana no <strong>Brasil</strong>
            </h3>
          </div>

          <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-3xl">
            A conformidade com normas técnicas brasileiras é obrigatória para projetos de impermeabilização
            em aterros sanitários, barragens e mineração. Abaixo, as principais normas aplicáveis à soldagem de geomembrana.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* NBR 16199 */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="bg-green-500 text-white text-[10px] font-black px-2 py-1 rounded uppercase tracking-wide">
                  ABNT
                </span>
                <span className="text-gray-900 font-black text-sm">NBR 16199</span>
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-3">
                Geomembranas de PEAD — Soldagem por Cunha Quente
              </h4>
              <ul className="space-y-2 text-gray-500 text-xs leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Define os parâmetros de <strong>temperatura, velocidade e pressão</strong> para soldagem de PEAD</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Especifica o <strong>teste de pressão no canal de teste</strong> como método de controle de qualidade</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Exige <strong>solda de teste (test weld)</strong> no início de cada jornada e a cada troca de rolo</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Aplicável a <strong>aterros sanitários, barragens e reservatórios</strong> no Brasil</span>
                </li>
              </ul>
            </div>

            {/* NBR 15352 */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="bg-green-500 text-white text-[10px] font-black px-2 py-1 rounded uppercase tracking-wide">
                  ABNT
                </span>
                <span className="text-gray-900 font-black text-sm">NBR 15352</span>
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-3">
                Geomembranas — Ensaios de Campo
              </h4>
              <ul className="space-y-2 text-gray-500 text-xs leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Norma para <strong>ensaio de tração e corte</strong> de amostras de solda retiradas no campo</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Define critérios de <strong>aceitação e rejeição</strong> da junta soldada com base na resistência mecânica</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Exige <strong>frequência mínima de amostragem</strong>: 1 amostra a cada 150 m de solda</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Complementa a <strong>NBR 16199</strong> no controle de qualidade pós-soldagem</span>
                </li>
              </ul>
            </div>

            {/* GSI */}
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6">
              <div className="flex items-center gap-2 mb-4">
                <span className="bg-green-500 text-white text-[10px] font-black px-2 py-1 rounded uppercase tracking-wide">
                  GSI
                </span>
                <span className="text-gray-900 font-black text-sm">Padrões Internacionais</span>
              </div>
              <h4 className="text-gray-900 font-black text-sm uppercase mb-3">
                Geosynthetic Institute — Referência Global
              </h4>
              <ul className="space-y-2 text-gray-500 text-xs leading-relaxed">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>GSI GM19</strong> — Guia de boas práticas para soldagem de geomembranas de PEAD</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>GSI GM28</strong> — Procedimentos de teste de pressão e vazamento em campo</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span><strong>ASTM D4437</strong> — Padrão americano para soldagem de geomembranas (referência complementar)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Adotado como <strong>referência técnica</strong> em projetos internacionais no Brasil</span>
                </li>
              </ul>
            </div>
          </div>

        </div>

        {/* ── 4. Diferencia entre cuña y extrusión ── */}
        <div id="comparativo-cunha-extrusao" className="mb-8 scroll-mt-24">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
              <i className="ri-table-line text-green-600" />
            </div>
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 uppercase tracking-wide">
              Diferença entre Soldagem por <strong>Cunha Quente</strong> e <strong>Extrusão</strong>
            </h3>
          </div>

          <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-3xl">
            A escolha entre <strong>cunha quente</strong> e <strong>extrusão</strong> depende do tipo de projeto,
            espessura da geomembrana, área de cobertura e necessidade de reparos. A tabela comparativa abaixo
            apresenta os critérios técnicos para decisão informada.
          </p>

          <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white mb-6">
            <table className="w-full text-sm border-collapse min-w-[700px]">
              <thead>
                <tr className="bg-gray-900 text-white">
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">
                    Critério Técnico
                  </th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">
                    <i className="ri-fire-line mr-1" />
                    Cunha Quente
                  </th>
                  <th className="text-left px-4 py-3 font-bold text-xs uppercase tracking-wide whitespace-nowrap">
                    <i className="ri-drop-line mr-1" />
                    Extrusão
                  </th>
                </tr>
              </thead>
              <tbody>
                {compareRows.map((row, i) => (
                  <tr
                    key={row.criterio}
                    className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/40'}`}
                  >
                    <td className="px-4 py-3 font-black text-gray-900 whitespace-nowrap text-xs uppercase tracking-wide">
                      {row.criterio}
                    </td>
                    <td className="px-4 py-3 text-gray-600 text-sm leading-relaxed">{row.cunha}</td>
                    <td className="px-4 py-3 text-gray-600 text-sm leading-relaxed">{row.extrusao}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-green-50 rounded-xl border border-green-100 p-5">
              <h4 className="text-green-900 font-black text-sm uppercase mb-2 flex items-center gap-2">
                <i className="ri-check-double-line text-green-600" />
                Quando usar Cunha Quente?
              </h4>
              <p className="text-green-800 text-xs leading-relaxed">
                Grandes áreas planas (aterros, barragens, canais), geomembranas de <strong>0,5–3,0 mm</strong>,
                projetos que exigem <strong>teste de pressão no canal de teste</strong> conforme <strong>NBR 16199</strong>.
                Melhor custo-benefício para longas jornadas de soldagem contínua.
              </p>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-100 p-5">
              <h4 className="text-gray-900 font-black text-sm uppercase mb-2 flex items-center gap-2">
                <i className="ri-check-double-line text-green-600" />
                Quando usar Extrusão?
              </h4>
              <p className="text-gray-600 text-xs leading-relaxed">
                Reparos, cantos, emendas, geomembranas <strong>espessas (&gt;2,0 mm)</strong>, junções em ângulo,
                reforços de bordas e locais de difícil acesso. Indispensável como equipamento complementar
                em todo projeto de impermeabilização profissional.
              </p>
            </div>
          </div>
        </div>

        {/* CTA final */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 bg-gray-900 rounded-2xl px-6 py-6">
          <div>
            <p className="text-white font-black text-sm uppercase tracking-wide mb-1">
              Precisa de orientação técnica para o seu projeto?
            </p>
            <p className="text-gray-400 text-xs leading-relaxed max-w-lg">
              Nossa equipe técnica analisa as especificações do seu projeto e indica o equipamento e método de soldagem
              mais adequados. <strong className="text-gray-300">Atendemos todo o Brasil</strong> com suporte pós-venda local.
            </p>
          </div>
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white font-black text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide flex-shrink-0"
          >
            <i className="ri-whatsapp-line" />
            Falar com Especialista
          </a>
        </div>

      </div>
    </section>
  );
}